import { useEffect, useState } from "react";
import { GetUserInfo, UpdateUserInfo } from "../../services/ApiServices/UserService";
import { Box, Typography, Dialog, DialogTitle, DialogContent, TextField, Button, DialogActions } from "@mui/material";

type ProfileProps = {
  id: string
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

type UserInfo = {
  id: string;
  userName: string;
  email: string;
  phoneNumber: string;
  dateOfBirth: string;
  address: string;
  hashPassword: string;
}

function Profile({ id, loading, setLoading }: ProfileProps) {
  const [userInfo, setUserInfo] = useState<UserInfo>({
    id: "",
    userName: "",
    email: "",
    phoneNumber: "",
    dateOfBirth: "",
    address: "",
    hashPassword: ""
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [open, setOpen] = useState(false);
  const [userName, setUserName] = useState('');
  const [email, setEmail] = useState(userInfo.email);
  const [phoneNumber, setPhoneNumber] = useState(userInfo.phoneNumber);
  const [address, setAddress] = useState(userInfo.address);
  const [birthday, setBirthday] = useState(userInfo.dateOfBirth);

  const handleOpen = () => setOpen(!open);

  const fetchUserInfo = async () => {
    setLoading(true);
    try {
      const userInfo = await GetUserInfo(id);
      setUserInfo(userInfo);
      setUserName(userInfo.userName);
      setEmail(userInfo.email);
      setPhoneNumber(userInfo.phoneNumber);
      setAddress(userInfo.address);
      setBirthday(userInfo.dateOfBirth);
    } catch (error: any) {
      setErrorMessage(error.response?.data?.message || 'An error occurred. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  const updateUserInfo = async () => {
    setLoading(true);
    try {
      const updatedUserInfo = {
        id: userInfo.id,
        userName: userName,
        email: email,
        phoneNumber: phoneNumber,
        dateOfBirth: birthday,
        address: address,
        hashPassword: userInfo.hashPassword
      };
      const user = await UpdateUserInfo(updatedUserInfo);
      setUserInfo(user);
      setLoading(false);
      handleOpen();
    } catch (error: any) {
      setErrorMessage(error.response?.data?.message || 'An error occurred. Please try again later.');
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserInfo();
  }, [id]);

  if (!userInfo.id) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Box className="user-info-wrapper mt-5 mb-5" sx={{ p: 4, bgcolor: 'background.paper', borderRadius: 2, boxShadow: 3, maxWidth: 800, mx: 'auto', display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography variant="h4" gutterBottom>
          <strong>Thông tin người dùng</strong>
        </Typography>
        <Typography variant="body1"><strong>Tên:</strong> {userInfo.userName}</Typography>
        <Typography variant="body1"><strong>Email:</strong> {userInfo.email}</Typography>
        <Typography variant="body1"><strong>Điện thoại:</strong> {userInfo.phoneNumber}</Typography>
        <Typography variant="body1"><strong>Ngày sinh:</strong> {userInfo.dateOfBirth}</Typography>
        <Typography variant="body1"><strong>Địa chỉ:</strong> {userInfo.address}</Typography>
        <Button variant="contained" color="warning" onClick={handleOpen} sx={{ mt: 2 }}>
          Edit
        </Button>
      </Box>
      <Dialog open={open} onClose={handleOpen}>
        <DialogTitle>Chỉnh sửa thông tin</DialogTitle>
        <DialogContent>
          <TextField
            label="Username"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            fullWidth
            margin="normal"
            disabled
          />
          <TextField
            label="Phone Number"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Address"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Birthday"
            type="date"
            value={birthday}
            onChange={(e) => setBirthday(e.target.value)}
            fullWidth
            margin="normal"
            InputLabelProps={{ shrink: true }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleOpen} color="secondary">
            Huỷ
          </Button>
          <Button onClick={() => { handleOpen(); updateUserInfo(); }} color="primary">
            Lưu
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Profile;
